import { AxiosError } from 'axios';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useOptionsForBinary } from '../../../hooks/api';
import { usePostManualsDownload } from '../../../api/manual/manual';
import BlobErrorModal from '../../modules/BlobErrorModal';
import SpinnerModal from '../../modules/SpinnerModal';
import { executeDownload } from '../../../utils/download';

type Props = {
  manualId: number;
};
function ManualDownload({ manualId }: Props) {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const [displaySpinnerModal, setDisplaySpinnerModal] = useState(false);
  const [displayDownloadError, setDisplayDownloadError] = useState(false);
  const optionsForBinary = useOptionsForBinary(language);

  const { mutateAsync: _downloadAsync, error: downloadError } =
    usePostManualsDownload<AxiosError<Blob>>(optionsForBinary);

  // ダウンロード処理
  const downloadAsync = useCallback(async () => {
    setDisplaySpinnerModal(true);
    const response = await _downloadAsync({ manualId });
    if (response.status === 200) {
      executeDownload(response);
      setDisplaySpinnerModal(false);
    } else {
      setDisplaySpinnerModal(false);
    }
  }, [manualId, _downloadAsync]);

  return (
    <>
      <li onClick={() => downloadAsync()} style={{ cursor: 'pointer' }}>
        <i className="fa-solid fa-download" />
        {t('ダウンロード')}
      </li>
      {/* スピナーモーダル */}
      {displaySpinnerModal && <SpinnerModal />}
      {/* 出力エラー */}
      {displayDownloadError && (
        <BlobErrorModal error={downloadError} onClickOk={() => setDisplayDownloadError(false)} />
      )}
    </>
  );
}

export { ManualDownload };
